// Canadian numbers only: 10 digits, after the country code 1 that the input adds ("+1 (403) 555-0146").
const phoneDigits = (phoneNumber?: string) => {
  const digits = (phoneNumber ?? '').replace(/\D/g, '');
  return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
};

/** Nothing entered: blank, or only the "+1" the input pre-fills. */
export const isEmptyPhoneNumber = (phoneNumber?: string) => {
  const digits = (phoneNumber ?? '').replace(/\D/g, '');
  return digits === '' || digits === '1';
};

export const isValidPhoneNumber = (phoneNumber?: string) => phoneDigits(phoneNumber).length === 10;

/** Something was entered but it is not a full number. */
export const isInvalidPhoneNumber = (phoneNumber?: string) =>
  !isEmptyPhoneNumber(phoneNumber) && !isValidPhoneNumber(phoneNumber);

/**
 * The value to save: "+1 (403) 555-0146" (the format the mobile app also saves), or '' when nothing
 * was entered.
 */
export const formatPhoneNumberForSave = (phoneNumber?: string) => {
  if (isEmptyPhoneNumber(phoneNumber)) return '';
  const d = phoneDigits(phoneNumber);
  return `+1 (${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};
